import React from 'react'

import S from './styled'

const IconButton = ({ onClick, children, red }) => (
  <S.IconButton onClick={onClick} red={red}>
    {children}
  </S.IconButton>
)

export default IconButton
